import React, { useRef } from 'react';
import { AriaMenuOptions, useMenu } from 'react-aria';
import { TreeProps, useTreeState } from 'react-stately';
import MenuList, { MenuListProps } from 'components/MenuList';
import MenuItem, { MenuLinkItem } from '../MenuItem';
import * as S from './styles';

export interface PopoverMenuProps<T extends object = object>
  extends TreeProps<T>,
    AriaMenuOptions<T>,
    Pick<MenuListProps, 'density'> {
  header?: React.ReactNode;
}

/**
 * Renders a menu inside of a `Popover`

 * @see https://react-spectrum.adobe.com/react-aria/useMenu.html
 */
export function PopoverMenu<T extends object>({
  density = 'default',
  header,
  ...props
}: PopoverMenuProps<T>): React.ReactElement | null {
  const listRef = useRef<HTMLUListElement>(null);
  const state = useTreeState(props);
  const { menuProps } = useMenu(props, state, listRef);

  return (
    <S.Root>
      {header}
      <MenuList {...menuProps} density={density} ref={listRef}>
        {Array.from(state.collection).map((item) =>
          item.props.linkComponent ? (
            <MenuLinkItem key={item.key} item={item} state={state} />
          ) : (
            <MenuItem key={item.key} item={item} state={state} />
          ),
        )}
      </MenuList>
    </S.Root>
  );
}

export default PopoverMenu;
